export const BASE = 'base';
export const FETCHING = 'fetching';
export const ERROR = 'error';
export const FETCHED = 'fetched';
export const POPULATING = 'populating';
export const POPULATED = 'populated';
